<!-- 溯源实例 -->
<template>
    <div class="container">
        <div class="content">
            <div>
                <Button class="theme-bg mb-24" icon="md-add-circle" type="warning" @click="goModal(1)">新增实例</Button>
                <Table :columns="columnsTable" :data="dataTable" border>
                    <template slot-scope="{ index }" slot="id">
                        <div>{{ index + 1 }}</div>
                    </template>
                    <template slot-scope="{ row }" slot="module_count">
                        <div class="flex-c" @click="goModule(row)">
                            <Button label="small">{{row.module_count}}</Button>
                        </div>
                    </template>
                    <template slot-scope="{ row }" slot="product_count">
                        <div class="flex-c" @click="goBind(row)">
                            <Button label="small">{{row.product_count + row.batch_count}}</Button>
                        </div>
                    </template>
                    <template slot-scope="{ row }" slot="operate">
                        <div class="flex-sa">
                            <Button type="primary" ghost label="small" @click="goModal(1, row)">编辑</Button>
                            <Button type="error" ghost label="small" @click="goDel(1, row)">删除</Button>
                        </div>
                    </template>
                </Table>
            </div>
            <div class="mt-24 ta-r">
                <Page :current="storePrams.page" :page-size="storePrams.limit" :total="total" show-elevator show-total @on-change="pageChange"/>
            </div>
        </div>
        <!-- 实例模块 -->
        <Modal v-model="moduleModal" title="实例模块" width="50" :mask-closable="false">
            <div>
                <Button class="theme-bg mb-24" icon="md-add-circle" type="warning" @click="goModal(3)">新增实例模块</Button>
                <Table :columns="columnModule" :data="dataModule" border>
                    <template slot-scope="{ index }" slot="id">
                        <div>{{ index + 1 }}</div>
                    </template>
                    <template slot-scope="{ row }" slot="node_count">
                        <div class="flex-c" @click="goNode(row)">
                            <Button label="small">{{row.node_count}}</Button>
                        </div>
                    </template>
                    <template slot-scope="{ row }" slot="operate">
                        <div class="flex-sa">
                            <Button type="primary" ghost label="small" @click="goModal(3, row)">编辑</Button>
                            <Button type="error" ghost label="small" @click="goDel(2, row)">删除</Button>
                        </div>
                    </template>
                </Table>
                <div class="mt-24 ta-r">
                    <Page :current="pageModule.page" :page-size="pageModule.limit" :total="totalModule" show-elevator show-total @on-change="changePageModule"/>
                </div>
            </div>
            <div slot="footer"></div>
        </Modal>
        <!-- 节点 -->
        <Modal v-model="nodeModal" title="节点" width="50" :mask-closable="false">
            <div>
                <Button class="theme-bg mb-24" icon="md-add-circle" type="warning" @click="goModal(2)">新增节点</Button>
                <Table :columns="columnNode" :data="dataNode" border>
                    <template slot-scope="{ index }" slot="id">
                        <div>{{ index + 1 }}</div>
                    </template>
                    <template slot-scope="{ row }" slot="operate">
                        <div class="flex-sa">
                            <Button type="primary" ghost label="small" @click="goModal(2, row)">编辑</Button>
                            <Button type="error" ghost label="small" @click="goDel(3, row)">删除</Button>
                        </div>
                    </template>
                </Table>
                <div class="mt-24 ta-r">
                    <Page :current="pageNode.page" :page-size="pageNode.limit" :total="totalNode" show-elevator show-total @on-change="changePageNode"/>
                </div>
            </div>
            <div slot="footer"></div>
        </Modal>
        <!-- 关联绑定 -->
        <Modal v-model="bindModal" title=" " width="50" :mask-closable="false">
            <div>
                <Menu mode="horizontal" :active-name="itemData.menuID" @on-select="selectMenu">
                    <MenuItem name="1">关联产品</MenuItem>
                    <MenuItem name="2">关联批次</MenuItem>
                </Menu>
                <div v-if="itemData.menuID == 1">
                    <Button class="theme-bg mt-24 mb-24" icon="md-add-circle" type="warning" @click="goModal(4)">新增关联产品</Button>
                    <Table :columns="columnProduct" :data="dataProduct" border>
                        <template slot-scope="{ index }" slot="id">
                            <div>{{ index + 1 }}</div>
                        </template>
                        <template slot-scope="{ row }" slot="product">
                            <div>{{row.product.product_name}}</div>
                        </template>
                        <template slot-scope="{ row }" slot="operate">
                            <div class="flex-sa">
                                <Button type="error" ghost label="small" @click="goDel(4, row)">删除</Button>
                            </div>
                        </template>
                    </Table>
                    <div class="mt-24 ta-r">
                        <Page :current="pageProduct.page" :page-size="pageProduct.limit" :total="totalProduct" show-elevator show-total @on-change="changePageProduct"/>
                    </div>
                </div>
                <div v-if="itemData.menuID == 2">
                    <Button class="theme-bg mt-24 mb-24" icon="md-add-circle" type="warning" @click="goModal(5)">新增关联批次</Button>
                    <Table :columns="columnBatch" :data="dataBatch" border>
                        <template slot-scope="{ index }" slot="id">
                            <div>{{ index + 1 }}</div>
                        </template>
                        <template slot-scope="{ row }" slot="batch">
                            <div>{{row.batch.batch_name}}</div>
                        </template>
                        <template slot-scope="{ row }" slot="operate">
                            <div class="flex-sa">
                                <Button type="error" ghost label="small" @click="goDel(5, row)">删除</Button>
                            </div>
                        </template>
                    </Table>
                    <div class="mt-24 ta-r">
                        <Page :current="pageBatch.page" :page-size="pageBatch.limit" :total="totalBatch" show-elevator show-total @on-change="changePageBatch"/>
                    </div>
                </div>
            </div>
            <div slot="footer"></div>
        </Modal>
        <!-- 编辑实例/新增实例/编辑节点/新增节点/编辑实例模块/新增实例模块/新增关联产品/新增关联批次 -->
        <Modal v-model="modals" :title="modalTitle" :width="modalWidth" :mask-closable="false">
            <div>
                <template v-if="modalID == 1">
                    <Form :model="formExample" label-position="right" :label-width="100">
                        <FormItem label="实例名称：">
                            <Input type="text" v-model="formExample.name" placeholder="请输入实例名称"></Input>
                        </FormItem>
                        <FormItem label="备注：">
                            <Input type="text" v-model="formExample.remarks" placeholder="请输入备注信息"></Input>
                        </FormItem>
                    </Form>
                </template>
                <template v-if="modalID == 2">
                    <Form :model="formNode" label-position="right" :label-width="100">
                        <FormItem label="节点名称：">
                            <Input type="text" v-model="formNode.name" placeholder="请输入节点名称"></Input>
                        </FormItem>
                        <FormItem label="节点内容：">
                            <Input type="text" v-model="formNode.content" placeholder="请输入节点内容"></Input>
                        </FormItem>
                        <FormItem label="图片：">
                            <div class="picture_div">
                                <div class="form_upload mb-24" @click="openModal(0, 1)">
                                    <Icon type="ios-add" size="40" color="#AEAEB3"/>
                                </div>
                                <draggable
                                    class="dragg_div"
                                    v-model="show_imgs"
                                    chosen-class="chosen"
                                    force-fallback="true"
                                    group="people"
                                    animation="500"
                                    :handle="'.dragg'"
                                    @start="onStart"
                                    @end="onEnd"
                                    >
                                        <div v-for="(item, index) in show_imgs" :key="index">
                                            <div class="form_upload mr-24 mb-24 position_relative dragg">
                                                <Icon class="form_upload_icon" size="20" type="ios-close-circle" color="#f00" @click="delImg(index)"/>
                                                <img class="width_height_100" :src="item">
                                            </div>
                                        </div>
                                </draggable>
                            </div>
                        </FormItem>
                        <FormItem label="视频：">
                            <div class="form_upload mb-24" @click="openModal(2, 2)">
                                <video class="width_height_100" v-if="formNode.video" :src="show_video"></video>
                                <Icon v-else type="ios-add" size="40" color="#AEAEB3"/>
                            </div>
                        </FormItem>
                        <FormItem label="地址：">
                            <Input type="text" v-model="formNode.address" placeholder="请输入地址信息"></Input>
                        </FormItem>
                        <FormItem label="时间：">
                            <DatePicker class="width_100" :value="formNode.node_time" type="datetime" placeholder="请选择时间" @on-change="changeNodeTime"></DatePicker>
                        </FormItem>
                        <FormItem label="排列序号：">
                            <Input type="text" v-model="formNode.sort" placeholder="请输入排列序号"></Input>
                        </FormItem>
                    </Form>
                </template>
                <template v-if="modalID == 3">
                    <Form :model="formModule" label-position="right" :label-width="100">
                        <FormItem label="模块名称：">
                            <Input type="text" v-model="formModule.name" placeholder="请输入模块名称"></Input>
                        </FormItem>
                        <FormItem label="排列序号：">
                            <Input type="text" v-model="formModule.sort" placeholder="请输入排列序号"></Input>
                        </FormItem>
                    </Form>
                </template>
                <template v-if="modalID == 4">
                    <Form :model="formProduct" label-position="right" :label-width="100">
                        <FormItem label="选择产品：">
                            <Select v-model="formProduct.product_id" clearable filterable placeholder="请选择产品">
                                <Option v-for="item in productList" :value="item.id" :key="item.id">{{ item.product_name }}</Option>
                            </Select>
                        </FormItem>
                    </Form>
                </template>
                <template v-if="modalID == 5">
                    <Form :model="formBatch" label-position="right" :label-width="100">
                        <FormItem label="关联批次：">
                            <Select v-model="formBatch.batch_id" clearable filterable placeholder="请选择批次">
                                <Option v-for="item in batchList" :value="item.id" :key="item.id">{{ item.batch_name }}</Option>
                            </Select>
                        </FormItem>
                    </Form>
                </template>
            </div>
            <div slot="footer">
                <Button @click="cancelModal">取消</Button>
                <Button class="theme-bg" type="warning" @click="submitModal">确认</Button>
            </div>
        </Modal>
        <pictureLibrary
            v-if="switch_modal"
            :switch_modal.sync="switch_modal"
            :select="imgtype"
            :select_type='select_type'
            @change="costPlannedAmountChange"
        ></pictureLibrary>
    </div>
</template>

<script>
import { 
    example_list, 
    example_save, 
    example_delete, 
    example_module_list, 
    example_module_save, 
    example_module_delete, 
    example_node_list, 
    example_node_save, 
    example_node_info,
    example_node_delete, 
    example_product_list, 
    example_batch_list, 
    example_product_save, 
    example_batch_save,
    example_product_delete, 
    example_batch_delete,
} from '@/api/index';
import { 
    product_select, 
    batch_select,
} from '@/api/select';
import config from "@/config/index";
import { getCookies } from "@/utils/helper";
import draggable from "vuedraggable";
import pictureLibrary from "@/components/picture/pictureLibrary.vue";
export default {
    components: { draggable, pictureLibrary },
    data() {
        return {
            select_type: 'image',
            srctype: "",
            imgtype: 1,
            switch_modal: false,
            uploadImg: config.apiUrl + "/adminapi/file_upload",
            headers: { "hlzw-suyuan-token": getCookies("pcToken") },
            itemData: { 
                menuID: "1",
                useValue: false,
                example_id: "",
                module_id: "",
            },
            storePrams: {
                page: 1,
                limit: 10,
            },
            total: 0,
            columnsTable: [
                { title: "#", slot: "id", align: "center", width: "60px" },
                { title: "实例名称", key: "name", align: "center" },
                { title: "备注", key: "remarks", align: "center" },
                { title: "实例模块", slot: "module_count", align: "center" },
                { title: "关联绑定", slot: "product_count", align: "center" },
                { title: "操作", slot: "operate", align: "center", width: "200px" },
            ],
            dataTable: [],
            moduleModal: false,
            nodeModal: false,
            bindModal: false,
            modals: false,
            modalTitle: '',
            modalWidth: '',
            modalID: '',
            pageModule: {
                page: 1,
                limit: 10,
                example_id: "",
            },
            totalModule: 0,
            columnModule: [
                { title: "#", slot: "id", align: "center", width: "60px" },
                { title: "排列序号", key: "sort", align: "center" },
                { title: "实例模块名称", key: "name", align: "center" },
                { title: "节点", slot: "node_count", align: "center" },
                { title: "操作", slot: "operate", align: "center", width: "200px" },
            ],
            dataModule: [],
            pageNode: {
                page: 1,
                limit: 10,
                module_id: "",
            },
            totalNode: 0,
            columnNode: [
                { title: "#", slot: "id", align: "center", width: "60px" },
                { title: "排列序号", key: "sort", align: "center" },
                { title: "节点名称", key: "name", align: "center" },
                { title: "操作", slot: "operate", align: "center", width: "200px" },
            ],
            dataNode: [],
            pageProduct: {
                page: 1,
                limit: 10,
                example_id: "",
            },
            totalProduct: 0,
            columnProduct: [
                { title: "#", slot: "id", align: "center", width: "60px" },
                { title: "产品名称", slot: "product", align: "center" },
                { title: "操作", slot: "operate", align: "center", width: "100px" },
            ],
            dataProduct: [],
            pageBatch: {
                page: 1,
                limit: 10,
                example_id: "",
            },
            totalBatch: 0,
            columnBatch: [
                { title: "#", slot: "id", align: "center", width: "60px" },
                { title: "批次名称", slot: "batch", align: "center" },
                { title: "操作", slot: "operate", align: "center", width: "100px" },
            ],
            dataBatch: [],
            nameList: [],
            formData: { name: "" },
            formExample: {
                id: "",
                name: "",
                remarks: "",
            },
            formModule: {
                id: "",
                name: "",
                example_id: "",
                sort: "",
            },
            formNode: {
                id: "",
                name: "",
                module_id: "",
                content: "",
                imgs: "",
                video: "",
                address: "",
                node_time: "",
                sort: "",
            },
            formProduct: {
                product_id: "",
                example_id: "",
            },
            formBatch: {
                batch_id: "",
                example_id: "",
            },
            imgs: [],
            show_imgs: [],
            show_video: "",
        };
    },
    mounted() {
        this.getList();
        this.getProductSelect();
        this.getBatchSelect();
    },
    methods: {
        // 事件处理函数
        async costPlannedAmountChange(param1, param2) {
            if (this.imgtype == 0 && this.srctype == 1) {
                for (var i = 0; i < param1.length; i++) {
                    this.show_imgs.push(param1[i]);
                }
                for (var i = 0; i < param2.length; i++) {
                    this.imgs.push(param2[i]);
                }
                this.$Message.destroy();
            } else if(this.srctype == 2) {
                for (var i = 0; i < param1.length; i++) {
                    this.show_video =  param1[i];
                }
                for (var i = 0; i < param2.length; i++) {
                   this.formNode.video = param2[i];
                }
                this.$Message.destroy();
            }
        },
        openModal(e, index) {
            this.imgtype = e;
            this.srctype = index;
            this.switch_modal = true;
            if(this.srctype == 2){ 
                this.select_type = 'video';
            }else{ 
                this.select_type = 'image';
            }
        },
        getList() {
            example_list(this.storePrams).then((res) => {
                this.dataTable = res.data.data;
                this.total = res.data.total;
            }).catch((err) => {
                this.$Message.error(err.msg);
            });
        },
        pageChange(index) {
            this.storePrams.page = index;
            this.getList();
        },
        changePageModule(index) {
            this.pageModule.page = index;
            this.getExampleModuleList();
        },
        changePageNode(index) {
            this.pageNode.page = index;
            this.getExampleNodeList();
        },
        changePageProduct(index) {
            this.pageProduct.page = index;
            this.getExampleProductList();
        },
        changePageBatch(index) {
            this.pageBatch.page = index;
            this.getExampleBatchList();
        },
        changeNodeTime(e){
            if(e){
                this.formNode.node_time = e;
            }else {
                this.formNode.node_time = '';
            }
        },
        getProductSelect(){
            product_select().then((res) => {
                this.productList = res.data;
            }).catch((err) => {
                this.$Message.error(err.msg);
            });
        },
        getBatchSelect(){
            batch_select().then((res) => {
                this.batchList = res.data;
            }).catch((err) => {
                this.$Message.error(err.msg);
            });
        },
        // 模块列表
        getExampleModuleList(){
            example_module_list(this.pageModule).then((res) => {
                this.dataModule = res.data.data;
                this.totalModule = res.data.total;
            }).catch((err) => {
                this.$Message.error(err.msg);
            });
        },
        // 节点列表
        getExampleNodeList(){
            example_node_list(this.pageNode).then((res) => {
                this.dataNode = res.data.data;
                this.totalNode = res.data.total;
            }).catch((err) => {
                this.$Message.error(err.msg);
            });
        },
        // 关联产品列表
        getExampleProductList(){
            example_product_list(this.pageProduct).then((res) => {
                this.dataProduct = res.data.data;
                this.totalProduct = res.data.total;
            }).catch((err) => {
                this.$Message.error(err.msg);
            });
        },
        // 关联批次列表
        getExampleBatchList(){
            example_batch_list(this.pageBatch).then((res) => {
                this.dataBatch = res.data.data;
                this.totalBatch = res.data.total;
            }).catch((err) => {
                this.$Message.error(err.msg);
            });
        },
        goDel(index, row){
            let that = this;
            this.$Modal.confirm({
                title: '删除提示',
                content: '确认删除吗？一经删除无法复原',
                onOk: () => {
                    if(index == 1){
                        example_delete({ id:row.id }).then(res=>{
                            that.getList();
                            this.$Message.success(res.msg);
                        }).catch(res=>{
                            this.$Message.error(res.msg);
                        })
                    }else if(index == 2){
                        example_module_delete({ id:row.id }).then(res=>{
                            that.getExampleModuleList();
                            this.$Message.success(res.msg);
                        }).catch(res=>{
                            this.$Message.error(res.msg);
                        })
                    }else if(index == 3){
                        example_node_delete({ id:row.id }).then(res=>{
                            that.getExampleNodeList();
                            this.$Message.success(res.msg);
                        }).catch(res=>{
                            this.$Message.error(res.msg);
                        })
                    }else if(index == 4){
                        example_product_delete({ id:row.id }).then(res=>{
                            that.getExampleProductList();
                            this.getList();
                            this.$Message.success(res.msg);
                        }).catch(res=>{
                            this.$Message.error(res.msg);
                        })
                    }else if(index == 5){
                        example_batch_delete({ id:row.id }).then(res=>{
                            that.getExampleBatchList();
                            this.getList();
                            this.$Message.success(res.msg);
                        }).catch(res=>{
                            this.$Message.error(res.msg);
                        })
                    }
                },
                onCancel: () => {
                }
            }); 
        },
        goModule(row){
            this.itemData.example_id = row.id;
            this.pageModule.example_id = row.id;
            this.getExampleModuleList();
            setTimeout(() => {
                this.moduleModal = true;
            }, 300);
        },
        goNode(row){
            this.itemData.module_id = row.id;
            this.pageNode.module_id = row.id;
            this.getExampleNodeList();
            setTimeout(() => {
                this.nodeModal = true;
            }, 300);
        },
        goBind(row){
            this.itemData.example_id = row.id;
            this.pageProduct.example_id = row.id;
            this.pageBatch.example_id = row.id;
            this.getExampleProductList();
            this.getExampleBatchList();
            setTimeout(() => {
                this.bindModal = true;
            }, 300);
        },
        goModal(index, row){
            this.modalID = index;
            if(index == 1){
                if(row){
                    this.modalTitle = '编辑实例';
                    this.modalWidth = 500;
                    this.formExample.id = row.id;
                    this.formExample.name = row.name;
                    this.formExample.remarks = row.remarks;
                }else{
                    this.modalTitle = '新增实例';
                    this.modalWidth = 500;
                    this.formExample.id = "";
                    this.formExample.name = "";
                    this.formExample.remarks = "";
                }
            }else if(index == 2){
                if(row){
                    this.modalTitle = '编辑节点';
                    this.modalWidth = 500;
                    example_node_info({ id:row.id }).then(res=>{
                        this.formNode.id = res.data.id;
                        this.formNode.name = res.data.name;
                        this.formNode.content = res.data.content;
                        this.formNode.imgs = res.data.imgs;
                        this.formNode.video = res.data.video;
                        this.formNode.address = res.data.address;
                        this.formNode.node_time = res.data.node_time;
                        this.formNode.sort = res.data.sort;
                        this.imgs = this.formNode.imgs.split(',');
                        this.show_imgs = res.data.show_imgs;
                        this.show_video = res.data.show_video;
                    }).catch(res=>{
                        this.$Message.error(res.msg);
                    })
                }else{
                    this.modalTitle = '新增节点';
                    this.modalWidth = 500;
                    this.formNode.id = "";
                    this.formNode.name = "";
                    this.formNode.content = "";
                    this.formNode.imgs = "";
                    this.formNode.video = "";
                    this.formNode.address = "";
                    this.formNode.node_time = "";
                    this.formNode.sort = "";
                    this.imgs = [];
                    this.show_imgs = [];
                    this.show_video = '';
                }
            }else if(index == 3){
                if(row){
                    this.modalTitle = '编辑实例模块';
                    this.modalWidth = 500;
                    this.formModule.id = row.id;
                    this.formModule.name = row.name;
                    this.formModule.sort = row.sort;
                }else{
                    this.modalTitle = '新增实例模块';
                    this.modalWidth = 500;
                    this.formModule.id = "";
                    this.formModule.name = "";
                    this.formModule.sort = "";
                }
            }else if(index == 4){
                this.modalTitle = '新增关联产品';
                this.modalWidth = 500;
                this.formProduct.product_id = "";
            }else if(index == 5){
                this.modalTitle = '新增关联批次';
                this.modalWidth = 500;
                this.formBatch.batch_id = "";
            }
            setTimeout(() => {
                this.modals = true;
            }, 500);
        },
        cancelModal(){
            this.modals = false;
        },
        // 确定
        submitModal(){
            if(this.modalID == 1){
                example_save(this.formExample).then( res => {
                    this.getList();
                    this.modals = false;
                    this.$Message.success(res.msg);
                }).catch(res=>{
                    this.$Message.error(res.msg);
                }) 
            }else if(this.modalID == 2){
                this.formNode.module_id = this.itemData.module_id;
                this.formNode.imgs = this.imgs.join(',');
                if(!this.formNode.name){
                    this.$Message.error('请输入节点名称');
                    return
                }
                if(!this.formNode.content){
                    this.$Message.error('请输入节点内容');
                    return
                }
                if(!this.formNode.address){
                    this.$Message.error('请输入地址信息');
                    return
                }
                if(!this.formNode.node_time){
                    this.$Message.error('请选择时间');
                    return
                }
                if(!this.formNode.sort){
                    this.$Message.error('请输入排列序号');
                    return
                }
                example_node_save(this.formNode).then( res => {
                    this.modals = false;
                    this.nodeModal = true;
                    this.getExampleNodeList();
                    this.$Message.success(res.msg);
                }).catch(res=>{
                    this.$Message.error(res.msg);
                })
            }else if(this.modalID == 3){
                this.formModule.example_id = this.itemData.example_id;
                if(!this.formModule.name){
                    this.$Message.error('请输入模块名称');
                    return
                }
                if(!this.formModule.sort){
                    this.$Message.error('请输入排列序号');
                    return
                }
                example_module_save(this.formModule).then( res => {
                    this.modals = false;
                    this.moduleModal = true;
                    this.getExampleModuleList();
                    this.$Message.success(res.msg);
                }).catch(res=>{
                    this.$Message.error(res.msg);
                })
            }else if(this.modalID == 4){
                this.formProduct.example_id = this.itemData.example_id;
                if(!this.formProduct.product_id){
                    this.$Message.error('请选择产品');
                    return
                }
                example_product_save(this.formProduct).then( res => {
                    this.modals = false;
                    this.getExampleProductList();
                    this.getList();
                    this.bindModal = true;
                    this.$Message.success(res.msg);
                }).catch(res=>{
                    this.$Message.error(res.msg);
                })
            }else if(this.modalID == 5){
                this.formBatch.example_id = this.itemData.example_id;
                if(!this.formBatch.batch_id){
                    this.$Message.error('请选择批次');
                    return
                }
                example_batch_save(this.formBatch).then( res => {
                    this.modals = false;
                    this.getExampleBatchList();
                    this.getList();
                    this.bindModal = true;
                    this.$Message.success(res.msg);
                }).catch(res=>{
                    this.$Message.error(res.msg);
                })
            }
        },
        selectMenu(name) {
            this.itemData.menuID = name;
        },
        delImg(index){
            this.imgs.splice(index, 1);
            this.show_imgs.splice(index, 1);
        },
        // 移动时
        onStart(e) {
            this.drag = true;
            console.log("触发移动", e);
        },
        // 移动结束
        onEnd(e) {
            this.drag = false;
            console.log("移动结束", e);
        },
    },
};
</script>

<style scoped>
.container {
    display: flex;
    flex-direction: column;
}
.content {
    padding: 24px;
    background: #ffffff;
    box-shadow: 0px 0px 4px 0px rgba(82, 102, 136, 0.1);
    border-radius: 5px;
    height: 100%;
}
.form_upload {
    width: 70px;
    height: 70px;
    background: #FFFFFF;
    border-radius: 5px;
    border: 1px dashed #9FA5BB;
    cursor: pointer;
    display: flex;
    align-items: center;
    justify-content: center;
}
.width_height_100 {
    width: 100%;
    height: 100%;
}
::v-deep .ivu-menu.ivu-menu-light.ivu-menu-horizontal{
    display: flex;
    align-items: center;
    justify-content: space-around;
}
::v-deep .ivu-menu-item {
    font-size: 16px;
}
::v-deep .ivu-menu-item:hover {
    font-size: 16px;
    color: #FF761D !important;
    border-bottom: 2px solid #FF761D !important;
}
::v-deep .ivu-menu-item.ivu-menu-item-active.ivu-menu-item-selected {
    color: #FF761D;
    font-size: 16px;
    border-bottom: 2px solid #FF761D !important;
}
::v-deep .ivu-checkbox-checked .ivu-checkbox-inner {
    border-color: #ff761d;
    background-color: #ff761d;
}
/* 表头背景颜色 */
::v-deep .ivu-table-header thead tr th {
    background: rgba(198, 44, 44, 0) !important;
    box-shadow: 0px 1px 0px 0px rgba(234, 234, 234, 0.99);
}
/* 表头字体颜色 */
::v-deep .ivu-table-wrapper .ivu-table .ivu-table-header tr th {
    color: #484e66 !important;
    font-weight: bold;
}
/* table中所有的边框  */
::v-deep .ivu-table td {
    border-left: none;
    border-right: none;
}
::v-deep .ivu-table th {
    border-left: none;
    border-right: none;
}
.picture_div {
    display: flex;
    flex-wrap: wrap;
    flex-direction: column;
}
.dragg_div {
    display: flex;
    flex-wrap: wrap;
}
.position_relative {
    position: relative;
}
.form_upload_icon {
    position: absolute;
    top: -10px;
    right: -10px;
}
.width_100 {
    width: 100%;
}
</style>